import { render, staticRenderFns } from "./add.vue?vue&type=template&id=672053d4&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672053d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('672053d4')) {
      api.createRecord('672053d4', component.options)
    } else {
      api.reload('672053d4', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=672053d4&scoped=true&", function () {
      api.rerender('672053d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/performancecenter/theater/add.vue"
export default component.exports